import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export class Label extends Vue {

  @Prop({type:String, required:true}) text:string;

  render(){
    return <label class="label is-small">{this.text}</label>;
  }
}


// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-487feb44/label.tsx" });